import { ClaveUnidadActionTypes, ClaveUnidadState, LOAD_CLAVESUNIDAD_SUCCESS } from "../types/claveUnidadActionTypes";


export default function claveUnidadReducer(state = [], action: ClaveUnidadActionTypes): ClaveUnidadState[]{
    switch (action.type) {
        case LOAD_CLAVESUNIDAD_SUCCESS:
            return action.clavesUnidad;
        default:
            return state;
    }
}
